import React from 'react';
export function ForWhoSection() {
  return <section className="w-full bg-white py-14 px-4 border-t border-gray-200" data-id="element-90">
      <div className="max-w-2xl mx-auto text-center" data-id="element-91">
        <h2 className="text-3xl md:text-4xl font-black text-black mb-8" data-id="element-92">
          📦 Todo lo que recibís hoy
        </h2>

        <ul className="text-left max-w-md mx-auto space-y-3 text-lg md:text-xl font-bold text-gray-800 mb-10" data-id="element-93">
          <li className="flex items-start" data-id="element-94">
            <span className="text-green-600 mr-3 flex-shrink-0" data-id="element-95">✓</span>
            Ebook Aprendizaje en Casa
          </li>
          <li className="flex items-start" data-id="element-96">
            <span className="text-green-600 mr-3 flex-shrink-0" data-id="element-97">✓</span>
            Bono 1: Lectura
          </li>
          <li className="flex items-start" data-id="element-98">
            <span className="text-green-600 mr-3 flex-shrink-0" data-id="element-99">✓</span>
            Bono 2: Matemática
          </li>
          <li className="flex items-start" data-id="element-100">
            <span className="text-green-600 mr-3 flex-shrink-0" data-id="element-101">✓</span>
            Bono 3: Cuentos
          </li>
        </ul>

        <p className="text-base font-bold text-gray-500 mb-10" data-id="element-102">
          ✔ Acceso inmediato &nbsp;&nbsp; ✔ Un solo pago &nbsp;&nbsp; ✔
          Descarga digital &nbsp;&nbsp; ✔ Uso de por vida
        </p>

        <div className="bg-green-50 border-2 border-green-200 p-6 inline-block" data-id="element-103">
          <p className="text-lg font-black text-green-700 uppercase mb-1" data-id="element-104">
            Garantía sin riesgo
          </p>
          <p className="text-base text-gray-700" data-id="element-105">
            Probalo. Si no es para vos, podés pedir devolución.
          </p>
        </div>
      </div>
    </section>;
}